import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../../utils";
import { getTextColor } from "./colors";
import { SDKData } from "./SDKData";
export const PriceMonitorCard = ({ data }) => {
    const { feeds } = data;
    const { total, failed } = feeds;
    const healthy = total - failed;
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: cn("flex flex-row items-start", getTextColor(feeds.status)), children: [_jsx("div", { className: "w-34", children: "Price feeds" }), _jsx("div", { children: `${healthy}/${total} healthy` })] }), _jsx(SDKData, { data: data })] }));
};
